
import { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import "./completesession.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleCompletesession, showToast } from "../Utils/utils";
import Loader from "../../Component/Loader/Loader";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Initiatecompletesession } from "../Redux/action/Completedsession";



const Completedsession = () => {
  let location = useLocation();
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [otp, setOtp] = useState('');
  const [second, setSecond] = useState(30)
  const [Loading, setLoading] = useState(false)
  const [isTimerCompleted, setIsTimerCompleted] = useState(false);
  const { sessioncompleteData, loading: loadingerror, error } = useSelector((state) => state.completesession);


  const session_id = new URLSearchParams(location.search).get('id');
  const Completesession = async () => {
    try {
      const response = await dispatch(Initiatecompletesession(session_id));
      showToast(response?.message, "success")
      setSecond(30);
      setIsTimerCompleted(false);
    } catch (error) {
      showToast(error.message, "error");
    }
  };

  const handleOptchnage = (otpValue) => {
    setOtp(otpValue)
  }

  const Completesessionfun = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      const response = await handleCompletesession({ session_id: sessioncompleteData?.data?._id, otp: otp })

      showToast(response?.message, "success")

      if (response.status === 200) {
        navigate('/dashboard');
        localStorage.removeItem("bookingsession")
      }

    } catch (error) {
      showToast(error.message, "error")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const session_id = new URLSearchParams(location.search).get('id');
    const bookingsessionid = localStorage.getItem("sessionid")
    if (!session_id || session_id !== bookingsessionid) {
      navigate('/dashboard');
      return;
    }

    if (sessioncompleteData?.data?.otp && second > 0) {
      const timer = setInterval(() => {
        setSecond((prevSecond) => {
          if (prevSecond > 1) {
            return prevSecond - 1;
          } else {
            clearInterval(timer);
            setIsTimerCompleted(true);
            return 0;
          }
        });
      }, 1000);
      return () => clearInterval(timer);
    }
    // }, [sessioncompleteData?.data?.otp, second]);
  }, [location.search, sessioncompleteData?.data?.otp, second, navigate]);


  return (
    <>
      {Loading && <Loader />}
      <div className="top-Otp">
        <div className="otp-wrapper px-4">
          <div className="mt-5">
            <Link to="/">
              <img className="img-fluid left-arrow-img " src="/Images/left-arrow.svg" alt="Logo" />
            </Link>
          </div>
          <form className="d-flex flex-column gap-3 justify-content-center" onSubmit={Completesessionfun}>
            <h4 className="title mt-3 ms-2">The user is sending your OTP.</h4>
            <div className="d-flex gap-2 ms-2">
              <label className="labeltext" htmlFor="OTP">
                Enter the OTP sent to  {sessioncompleteData?.data?.user?.phone_number}
              </label>
              {/* <span className="edit-otp">Edit</span> */}
            </div>
            <div className="otp-wrppaer">
              <OtpInput className="w-100"
                value={otp}
                onChange={handleOptchnage}
                numInputs={4}
                separator={<span> </span>}
                renderInput={(props) => (
                  <input className="otp-input gap-5"
                    {...props}
                    type="tel"
                    pattern="[0-9]*"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    style={{
                      width: "50px",
                      padding: "10px",
                      margin: "0 8px",
                      borderRadius: "10px",
                      background: "#ffffff",
                      border: "1px solid #d0d5dd",
                      boxShadow: "0px 1px 2px 0px #1018280d",
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: "bold",
                      outline: "none",
                      color: "#000000",
                    }}
                  />
                )}

              />
            </div>
            <div className="d-flex align-items-center">
              {second > 0 ? (
                <span className="resend-otp-btn ms-2">
                  Resend OTP in 00:{second > 9 ? second : `0${second}`}
                </span>
              ) : (
                <span
                  className="resend-otp-resp ms-2"
                  onClick={Completesession}
                  style={{ cursor: "pointer" }}
                >
                  Resend OTP
                </span>
              )}
            </div>


            <div className='submitbtn-res d-sm-block d-lg-none d-md-none'>
              <button className='continue-btn-res mt-2' type='submit'>
                <span className='continuebtn-text'>Continue</span>
              </button>
            </div>
            <div className='submitbtn-wrapper d-lg-block d-md-block d-xl-block d-xxl-block d-none'>
              <button className='continue-btn mt-3' type='submit'>
                <span className='continuebtn-text'>Continue</span>
              </button>
            </div>
          </form>

        </div>
      </div>
    </>
  );
};
export default Completedsession;
